import React from 'react';
import { observer } from 'mobx-react-lite';
import { Window, WindowHeader } from '../overlays';
import { Button } from '../input';
import { DeleteStreamWindowState } from './deleteStreamWindowState';

type Props = {
  model: DeleteStreamWindowState;
  visible?: boolean;
};

export const DeleteStreamWindow = observer((props: Props) => {
  const { model } = props;

  return (
    <Window
      model={model.window}
      visible={props.visible}
      isLoading={model.isLoading}>
      <WindowHeader model={model.window} title="Delete this stream?" />

      <hr />

      <div className="window-content">
        <p className="p-bold">Are you sure you want to delete this stream {model.streamName}?</p>
        <p>You are about to remove the connections between your stream hosting service and CLIPr. </p>
        <p>This means that video from this session will not be ingested and analyzed.</p>
      </div>

      <hr />

      <footer className="window-footer">
        <div className="btn-group right">
          <Button
            className="primary btn-outline medium"
            label="Cancel"
            onClick={() => model.close()} />
          <Button
            className="red medium"
            label="Delete"
            onClick={() => model.submit()} />
        </div>
      </footer>
    </Window>
  );
});
